import React, { useEffect, useState, useRef } from 'react';
import './PriceHeader.css';

const PriceHeader = ({
    instrument,
    timeframe,
    provider,
    currentPrice,
    previousPrice,
    darkMode
}) => {
    const [isFlashing, setIsFlashing] = useState(false);
    const prevPriceRef = useRef(currentPrice);

    // Calculate price change
    const priceChange = currentPrice && previousPrice
        ? currentPrice - previousPrice
        : 0;
    const percentChange = previousPrice && previousPrice !== 0
        ? ((priceChange / previousPrice) * 100)
        : 0;
    const isPositive = priceChange >= 0;

    // Flash animation on price update
    useEffect(() => {
        if (currentPrice !== prevPriceRef.current && currentPrice) {
            setIsFlashing(true);
            const timer = setTimeout(() => setIsFlashing(false), 300);
            prevPriceRef.current = currentPrice;
            return () => clearTimeout(timer);
        }
    }, [currentPrice]);

    // Format price based on instrument type
    const formatPrice = (price) => {
        if (!price) return '--';
        // Forex typically has 5 decimal places, crypto varies
        return price.toFixed(5);
    };

    // Format change values
    const formatChange = (value) => {
        if (!value || isNaN(value)) return '0.00000';
        const absValue = Math.abs(value);
        return absValue.toFixed(5);
    };

    const formatPercent = (value) => {
        if (!value || isNaN(value)) return '0.00';
        return Math.abs(value).toFixed(2);
    };

    if (!instrument) return null;

    // Format instrument label (e.g. EUR_USD -> EUR/USD)
    const formattedInstrument = instrument.replace('_', '/');
    const displayProvider = provider ? provider.toUpperCase() : '';

    // TradingView style legend string
    // e.g. "EUR/USD • M15 • OANDA"
    const legendString = `${formattedInstrument} • ${timeframe || ''} • ${displayProvider}`;

    return (
        <div className={`ntc-price-header ${darkMode ? 'dark' : 'light'}`}>
            <div className="ntc-price-header-legend">
                <span className="ntc-price-header-symbol">{legendString}</span>
            </div>

            <div className={`ntc-price-header-price-group ${isFlashing ? 'flash' : ''}`}>
                <span className={`ntc-price-header-price ${isPositive ? 'up' : 'down'}`}>
                    {formatPrice(currentPrice)}
                </span>

                {(priceChange !== 0 || percentChange !== 0) && (
                    <div className={`ntc-price-header-change ${isPositive ? 'up' : 'down'}`}>
                        <span className="ntc-price-header-change-value">
                            {formatChange(priceChange)}
                        </span>
                        <span className="ntc-price-header-percent">
                            {formatPercent(percentChange)}%
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PriceHeader;
